import React from 'react';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import { Box, Button, TextField } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

interface AppServiceEditProps {
  onSubmit: () => void;
  appServiceId: string;
  proto?: string;
  port?: string;
  fqdn?: string;
  // serviceDownTimeout?: number;
}
export const AppServiceEdit = ({
  onSubmit,
  appServiceId,
  proto,
  port,
  fqdn,
}: // serviceDownTimeout,
AppServiceEditProps) => {
  const api = useApi();
  const [appProtocol, setAppProtocol] = React.useState<string | undefined>(proto);
  const [appPort, setAppPort] = React.useState<string | undefined>(port);
  const [appFqdn, setAppFqdn] = React.useState<string | undefined>(fqdn);
  // const [appServiceDown, setAppServiceDown] = React.useState<number | undefined>(serviceDownTimeout);

  const appServiceEditPost = useMutation(api.editAppServiceApiV1EditAppServicePost, {
    onSuccess() {
      toast.success('Updated App Service successfully.');
      onSubmit();
    },
    onError: apiError,
  });

  const handleSubmit = () => {
    appServiceEditPost.mutate({
      app_service_id: appServiceId,
      ...(appProtocol !== undefined && { proto: appProtocol }),
      ...(appPort !== undefined && { port: appPort }),
      ...(appFqdn !== undefined && { fqdn: appFqdn }),
      // ...(appServiceDown !== undefined && { service_down_timeout: appServiceDown }),
    });
  };

  return (
    <Box pt={2}>
      <TextField
        sx={{ mb: 4 }}
        fullWidth
        label="App Service Id"
        variant="outlined"
        value={appServiceId}
        disabled
      />
      <TextField
        sx={{ mb: 4 }}
        fullWidth
        label="Protocol"
        variant="outlined"
        value={appProtocol}
        onChange={(e) => setAppProtocol(e.target.value)}
        helperText="Protocol used by the application."
        autoFocus
      />
      <TextField
        sx={{ mb: 4 }}
        fullWidth
        label="Port"
        variant="outlined"
        value={appPort}
        onChange={(e) => setAppPort(e.target.value)}
        helperText="Port number on which the application is running."
      />
      <TextField
        sx={{ mb: 4 }}
        fullWidth
        label="App's local FQDN name or IP address"
        variant="outlined"
        value={appFqdn}
        onChange={(e) => setAppFqdn(e.target.value)}
        helperText="Fully Qualified Domain Name"
      />
      {/* <TextField
        sx={{ mb: 4 }}
        fullWidth
        type="number"
        label="Service Down Timeout"
        variant="outlined"
        value={appServiceDown}
        onChange={(e) => setAppServiceDown(Number(e.target.value) || 0)}
        helperText="Time period after which the application will be declared down when it does not respond to connection requests."
      /> */}

      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit}>
          Save App Service
        </Button>
      </Box>
    </Box>
  );
};
